function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line no-restricted-imports
import { forwardRef } from 'react';
/**
 * @private Please use `Table.<cell-name>` from `@melio/penny`.
 *
 * Do not use this function directly.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export function createTableCell(Comp) {
  var TargetComponent = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(Comp, _objectSpread({
    ref: ref
  }, props)));

  if (Comp.displayName) {
    TargetComponent.displayName = "Table.".concat(Comp.displayName.replace('_Table', ''));
  }

  return TargetComponent;
}
//# sourceMappingURL=utils.js.map